import { getConsumerFor } from "../consumer";
import {Subscription} from "@rails/actioncable";

export class CandidacyCopierChannelSubscription {
  public subscription: Subscription;

  constructor(candidacyCopierId: number, { received, connected = undefined, disconnected = undefined }) {
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: "Candidacy::CandidacyCopierChannel",
        candidacy_copier_id: candidacyCopierId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}